<template>
    <div class="videopage">
      <v-menu></v-menu>
      <div class="pagebg">
        <div class="videoage">
          <div class="bread_nav">
            <div class="left bread_item">
              <ul class="left">
                <router-link class="left tagli index" :to="{name:'index'}" tag="li" active-class="active">首页&nbsp; &gt;&nbsp;</router-link>
                <router-link class="left tagli" :to="{name:'pcVideo'}" tag="li" active-class="active">心密视频</router-link>
              </ul>
              <div class="clear clearfix"></div>
            </div>
            <div class="search right">
              <input v-model="title"  type="text" placeholder="输入关键字搜索" @keyup.enter="searchVideo()"/>
            </div>
            <div class="clear clearfix"></div>
          </div>
          <div class="video_main">
            <div class="video_content left">
              <video ref="video_play" controls id="videoplay" src="" ></video>
              <div class="isplay" v-if="isPlay" @click="playVideo" >
                <div class="img">
                  <img src="../../../assets/images/stop.png" alt="播放">
                </div>
              </div>
              <div class="control_play">
                <div class="left chosevideo">
                  <div class="asswork left">{{videoName}}</div>
                  <!--<div class="item  left" :class="{'active':currentVideo==1}">上集</div>-->
                  <!--<div class="item left" :class="{'active':currentVideo==2}">下集</div>-->
                  <div class="clear clearfix"></div>
                </div>
                <div class="right download">
                    <div class="downtxt" @click="downVideo">下载</div>
                </div>
                <div class="clear clearfix"></div>
              </div>
            </div>
            <div class="video_list left">
              <div class="about">相关剧集</div>
              <ul>
                <li class="main-video" v-for="(item, index) of videoList">
                    <div class="audio-name"  @click="showHide(index)">
                      <div class="left imgbox" >
                        <img ref="arrow" v-if="item.down==0" class="iconfont" src="../../../assets/images/arrowright.png">
                        <img ref="arrow" v-else class="iconfont" src="../../../assets/images/arrowdown.png">
                      </div>
                      <div class="left subnamebox">
                        <div class="img-l-name textover" :class="{'active':item.id==chaptid}">{{item.className}}</div>
                      </div> 
                      <div class="clear clearfix"></div>
                    </div>
                    <div class="nextclass" :class="{'showbox':item.down==1}" ref="child" >
                      <div class="body-l">
                        <div class="body-l-name textover"  :id="'a'+items.id" :class="{'active':items.id==fileid}" @click="selectVideo(item,index,items,indexs)"  v-for="(items,indexs) in item.list">{{items.title}}</div>
                      </div>
                    </div>
                </li>
              </ul>
            </div>
            <div class="clear clearfix"></div>
          </div>
        </div>
        <!--没有搜索到视频-->

        <transition name="fade">
          <div class="pagemode modehide"  v-if="veidoRes==1">
            <div class="novideo">
              <div class="novideo_main" >
                <div class="txt">{{msgContent}}</div>
                <div class="close" @click="hideSearch">
                  <img src="../../../assets/images/close.png" alt="关闭" title="关闭">
                </div>
              </div>
            </div>
          </div>
        </transition>
        <!--搜索到结果-->
        <transition name="fade">
          <div class="pagemode modehide" v-if="veidoRes==2" >
            <div class="videoResList"  >
              <div class="videoResList_main">
                <div class="close" @click="hideSearch">
                  <img src="../../../assets/images/close.png" alt="关闭" title="关闭">
                </div>
                <div class="listgroup">
                  <div class="listitem">
                    <div class="item  filename left">名称</div>
                    <div class="left item options">关键词</div>
                    <div class="left item videolong">时长</div>
                    <div class="clear clearfix"></div>
                  </div>
                  <div class="listitem" @click="selectSearch(item,index)" v-for="(item,index) in searchVideoList">
                    <a :href="'#a'+item.classId">
                      <div class="left filename item textover">
                       {{item.classTitle}}
                      </div>
                      <div class="left item options textover">{{item.keyword}}</div>
                      <div class="left item videolong">{{item.start}}-{{item.end}}</div>
                      <div class="clear clearfix"></div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="page">
                <template>
                  <mo-paging
                    :page-index="currentPage"
                    :total="count"
                    :page-size="pageSize"
                    @change="pageChange">
                  </mo-paging>
                </template>
              </div>
            </div>

          </div>

        </transition>
      </div>
      <mode v-if="loadMode"></mode>
      <v-footer></v-footer>
    </div>
</template>

<script>
    import mode from '@/components/bg/mode'
    import MoPaging from '@/components/page/page'
    export default {
        name: "videopage",
        components:{
          mode,MoPaging
        },
        data() {
            return {
              isPlay:true,
              down:0,
              chaptid:0,
              fileid:0,
              veidoRes:0,
              videoList:[],
              loadMode:true,
              videoName:'',
              videoUrl:'',
              title:'',
              msgContent:'',
              searchVideoList:[],
              pageSize : 20 , //每页显示6条数据
              currentPage : 1, //当前页码
              count : 0, //总记录数
            }
        },
        mounted() {
          let _this=this;
          console.log(document.getElementById("videoplay"))
          this.$refs.video_play.addEventListener('pause', function (e) {
            console.log('aaaa')
            _this.isPlay=true
          })
          this.$refs.video_play.addEventListener('play', function (e) {
            console.log('aaaa')
            _this.isPlay=false
          })
          this.getList()

        },
        methods: {
          pageChange (page) {
            console.log(page)
            this.currentPage = page
            this.searchVideo()
          },
          playVideo(){
            if(this.$refs.video_play.paused){
              this.$refs.video_play.play()
              this.isPlay=false
            }else{
              this.isPlay=true
              this.$refs.video_play.pause()
            }
          },
          showHide(index) {
             if(this.videoList[index].down==0){
               this.videoList[index].down=1
             }else{
               this.videoList[index].down=0
             }
          },
          selectSearch(items,index){
            console.log(items)
            console.log(index)
            console.log(111)
            this.chaptid=items.file_id[0].category_id
            let indexs
            let itemArr=[]
            let findItemArr=[]
            this.videoList.map((item,index,arr)=>{
              item.down=0
              if(item.id==items.file_id[0].category_id){
                console.log(item)
                indexs=index
                console.log(indexs)
                return itemArr=item
              }
            })
            console.log(findItemArr)
            this.videoList[indexs].down=1
            console.log(itemArr)
            console.log(itemArr.list[0])
            this.fileid=items.classId
            this.$refs.video_play.src=items.file_id[0].save_url
            this.$refs.video_play.currentTime=items.start_seconds
            this.videoUrl=items.file_id[0].save_url
            this.videoName=items.classTitle
            let videoInfo={classid:items.id,fileid:this.fileid,videourl:this.videoUrl,index:indexs,videoname:this.videoName}
            window.localStorage['video']=JSON.stringify(videoInfo)
            this.veidoRes=0
          },
          selectVideo(item,index,items,indexs){
            console.log(222)
            this.chaptid=item.id
            this.fileid=items.id
            this.$refs.video_play.src=items.save_url
            this.videoUrl=items.save_url
            this.videoName=item.className+'-'+items.title
            let videoInfo={classid:item.id,fileid:items.id,videourl:items.save_url,index:index,videoname:item.className+'-'+items.title}
            window.localStorage['video']=JSON.stringify(videoInfo)
          },
          searchVideo(){
            this.loadMode=true
            this.$http({
              url: '/Video/find',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {title:this.title,page:this.currentPage}
            }).then((res) => {
              console.log(res)
              this.loadMode=false
              if(res.data.code==0){
                this.veidoRes=2
                res.data.data.data.map((item,index,arr)=>{
                 item.filename=item.classTitle.split(' ')[0]
                 item.videoTitle=item.classTitle.split(' ')[1]||item.classTitle.split('  ')[1]
                 return item
                })
                this.count=res.data.data.count
                this.searchVideoList=res.data.data.data

                // this.videoListScroll(res.data.data.info.page_sum)
                console.log(this.searchVideoList)
              }else{
                console.log('222')
                this.veidoRes=1
                this.msgContent=res.data.msg
              }
            })
            .catch((error) => {
              this.$layer.msg('网络错误')
              // error
              console.log(error)
            })
          },

          hideSearch(){
            this.veidoRes=0
            this.currentPage=1
          },
          async downVideo(){
            this.$layer.msg("正在下载,请稍后",{icon:1});//提示框
            let response = await fetch(this.videoUrl); // 内容转变成blob地址
            console.log(response)
            let blob = await response.blob();  // 创建隐藏的可下载链接
            let objectUrl = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = objectUrl;
            a.download = this.videoName;
            a.click()
            a.remove();
            this.$layer.msg("文件下载成功",{icon:1});
          },
          getList(){
            this.$http({
              url: '/Video/search',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {title:this.title}
            }).then((res) => {
              console.log(res)
                this.loadMode=false
                if(res.data.code==0){
                  this.videoList=res.data.data.map((item,index,arr)=>{
                      item.down=0
                      return item
                  })
                  this.loadMode=false
                  if(window.localStorage['video']){
                    let videoInfo=JSON.parse(window.localStorage['video'])
                    this.videoList[videoInfo.index].down=1
                    this.chaptid=videoInfo.classid
                    this.fileid=videoInfo.fileid
                    this.videoName=videoInfo.videoname
                    this.videoUrl=videoInfo.videourl
                    this.$nextTick(()=>{
                      this.$refs.video_play.src=videoInfo.videourl
                    })
                  }else{
                    this.videoList[0].down=1
                    this.chaptid=this.videoList[0].id
                    this.fileid=this.videoList[0].list[0].id
                    this.videoName=this.videoList[0].className+'-'+this.videoList[0].list[0].title
                    this.videoUrl=this.videoList[0].list[0].save_url
                    this.$nextTick(()=>{
                      this.$refs.video_play.src=this.videoList[0].list[0].save_url
                    })
                  }
                }else{
                    console.log('222')
                    this.veidoRes=1
                    this.msgContent=res.data.msg
                }
            })
            .catch((error) => {
              // error
              this.$layer.msg('网络错误，请稍后重试')
              console.log(error)
            })
          }
        }
    }
</script>
<style scoped lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .videoage{
    width:95rem;
    padding-left:9rem;
    box-sizing: border-box;
    margin:0 auto 0;
    position: relative;
    height:100%;
    .bread_nav{
      padding-top:2rem;
      .bread_item{
        height:3rem;
        .tagli{
          height:3rem;
          font-size:1.1rem;
          color:#5f4009;
          line-height: 3rem;
        }
        .index{
          background:url("../../../assets/images/nav.png")no-repeat left center;
          background-size:1rem auto;
          padding-left:2rem;
        }
      }
      .search{
        width:27rem;
        height:100%;
        input{
          width:27rem;
          height:3rem;
          border-radius:0.4rem;
          border:1px solid #c9a168;
          padding-left:4rem;
          box-sizing: border-box;
          background: url("../../../assets/images/search.png")no-repeat 1rem center #fff;
          background-size:1.5rem auto;
          font-size:1.2rem;
        }
      }
    }
    .video_main{
      height:41rem;
      background: #443f37;
      width:100%;
      margin:2rem 0;
      .video_content{
        width:70%;
        background: #443f37;
        position: relative;
        video{
          width:100%;
          height:36rem;
          object-fit: fill;
          cursor: pointer;
          display: block;
          background: #000;
        }
        .isplay{
          position: absolute;
          top:0;
          left:0;
          height:36rem;
          width:100%;
          background:rgba(0,0,0,0.2);
          .img{
            width:100%;
            height:100%;
            cursor: pointer;
            img{
              position: absolute;
              top:0;
              bottom:0;
              left:0;
              right:0;
              margin:auto;
              width:4rem;
            }
          }
        }
        .control_play{
          height:5rem;
          background: #443f37;
          .chosevideo{
            .asswork{
              font-size:1.4rem;
              color:#fff;
              padding:0 1.4rem;
              margin:0.8rem 0 0 0;
              line-height:3rem;
              height:3rem;
            }
            .item{
              width:5rem;
              height:3rem;
              border-radius:3px;
              border:1px solid #fff;
              font-size:1.1rem;
              color:#fff;
              text-align: center;
              line-height:3rem;
              margin:0.8rem 10px 0 0;
              cursor: pointer;
            }
            .item.active{
              color:#eec790;
              border:1px solid #eec790;
            }
          }
        }
        .download{
          padding-right:1rem;
          .downtxt{
            background:url("../../../assets/images/down.png")no-repeat center 0.8rem;
            background-size:1.5rem auto;
            font-size:1rem;
            color:#fff;
            padding-top:2.5rem;
            cursor: pointer;
          }
        }
      }
      .video_list{
        width:30%;
        padding:0 0 0 1.4rem;
        box-sizing: border-box;
         background: #443f37;
        height:100%;
        ul{
          height:33rem;
          overflow-y: auto;
          .main-video{

          }
          .showbox{
            height:auto;
          }
        }
        .audio-name{
          margin-top:1rem;
          .imgbox{
            width:1.5rem;
          }
        }
        .about{
          color:#fff;
          font-size:1.4rem;
          padding:1.4rem 0 0;
        }
        .iconfont{

        }

        .subnamebox{
          width:90%;
          .img-l-name{
            color:#fff;
            font-size:1.1rem;
            padding-left:0.7rem;
            box-sizing: border-box;
            cursor: pointer;
          }
          .active{
            color:#eec790;
          }
        }

        .body-l-name{
          color:#fff;
          font-size:1.1rem;
          padding-left:2.5rem;
          cursor: pointer;
        }
        .nextclass{
         display: none;
          .active{
            color:#eec790;
          }
        }
        .showbox{
          display: block;
        }
      }
    }
  }
  /*.showmode{*/
    /*opacity: 1 !important;*/
  /*}*/
  .novideo{
    width:28rem;
    height:11rem;
    background: #fff;
    border-radius:10px;
    position: absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
    margin:auto;
    .novideo_main{
      height:100%;
      width:100%;
      position: relative;
      line-height: 11rem;
      .txt{
        line-height: 11rem;
        text-align: center;
        font-size:1.5rem;
        color:#614513;
      }
      .close{
        width:2rem;
        position: absolute;
        height:2rem;
        top:0.7rem;
        right:0.7rem;
        padding:0.5rem;
        cursor: pointer;
        img{
          width:2rem;
          height:2rem;
        }
      }
    }
  }
  .videoResList{
    width:71rem;
    height:41rem;
    position: absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
    margin:auto;
    background: #fff;
    border-radius:10px;

    .videoResList_main{
      position: relative;
      width:100%;
      height:90%;
      overflow-y: auto;
      .close{
        width:2rem;
        position: absolute;
        height:2rem;
        top:0.7rem;
        right:0.7rem;
        padding:0.5rem;
        cursor: pointer;
        img{
          width:2rem;
          height:2rem;
        }
      }
      .listgroup{
        padding:4rem 2.5rem;
        box-sizing: border-box;
        .listitem:first-child{
          border-bottom:none;
        }
        .listitem:hover{
          color:#c9a168;
        }

        .listitem{
          border-bottom:1px dashed #ebebeb;
          a{
            display: block;
            padding:1rem 0;
          }
          a:hover{
            color:#c9a168;
          }
          .item{
            text-align: center;
            font-size:1.1rem;
            cursor: pointer;
          }
          .filename{
            width:35%;
          }
          .options{
            width:35%;
          }
          .videolong{
            width:30%;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/video/video.vue